import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueMobileDetection from "vue-mobile-detection";
import "bootstrap/dist/js/bootstrap.js";
import YouTube from "vue3-youtube";
import Toaster from "@meforma/vue-toaster";
import "./styles/global.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"; //!!!!!!!!!!! important import only icons that will be used !!!!!!!!!!!!!!!!
import {
  faUserSecret,
  faPhone,
  faEnvelope,
  faHome,
  faGem,
  faChevronDown,
  faChevronUp,
  faArrowDown,
  faDesktop,
  faMobile,
  faServer,
  faRocket,
  faCheck,
  faMailBulk,
  faQuoteLeft,
  faPlay,
  faSearch,
  faChevronLeft,
  faList,
  faListCheck,
  faFileInvoice,
  faMagnifyingGlassLocation,
  faQrcode,
  faFileSignature,
  faFileContract,
  faTable,
  faChartPie,
  faFileCsv,
  faMoneyBillTransfer,
  faDiagramNext,
  faRectangleList,
  faAddressCard,
  faWarehouse,
  faCalculator,
  faFileAlt,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
  faJava,
  faVuejs,
  faReact,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faUserSecret,
  faLinkedin,
  faFacebook,
  faTwitter,
  faInstagram,
  faPhone,
  faEnvelope,
  faHome,
  faGem,
  faChevronDown,
  faChevronUp,
  faJava,
  faVuejs,
  faReact,
  faDesktop,
  faMobile,
  faServer,
  faRocket,
  faCheck,
  faMailBulk,
  faQuoteLeft,
  faPlay,

  faSearch,
  faChevronLeft,
  faList,
  faListCheck,
  faFileInvoice,
  faMagnifyingGlassLocation,
  faQrcode,
  faFileSignature,
  faFileContract,
  faTable,
  faChartPie,
  faFileCsv,
  faMoneyBillTransfer,
  faDiagramNext,
  faRectangleList,
  faAddressCard,
  faWarehouse,
  faCalculator,
  faFileAlt,
  faChartBar
);

createApp(App)
  .use(i18n)
  .use(store)
  .use(AOS.init())
  .use(router)
  .use(Toaster)
  .use(VueMobileDetection)
  .component("YouTube", YouTube)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
import "bootstrap/dist/js/bootstrap.js";
